import { RequestsTable } from '@/components/Templates/Requests/RequestsTable';

const Requests = () => {
	return <RequestsTable />;
};

export default Requests;

